/**
 * Add a loading state to the Gravity Forms submit button.
 *
 * @param event Event object.
 * @param form_id Form ID.
 * @return void
 */
jQuery(document).on('gform_post_render', function (event, form_id) {
	var $form = jQuery('#gform_' + form_id);

	$form.on('submit', function () {
		$form.find('.gform_button').addClass('button-loading');
	});
});
